import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shallowEqual from 'recompose/shallowEqual';
import Moment from 'moment';
import { daysBetween } from '../../helper/unit-helper';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import { Popup } from 'components/Popup/popup';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import Datetime from 'react-datetime';
// import { formatTimezoneDateTime } from 'helper/unit-helper';
import * as WorkOrderActionType from '../constants';
import * as ProjectActionType from '../../Projects/constants';
import * as LotActionType from '../../Lots/constants';
import * as WOTActionType from '../../Work-Order-Type/constants';
import * as TradeActionType from '../../Trades/constants';
import * as ItemActionType from '../../Items/constants';
import * as SubcontractorActionType from '../../Subcontractors/constants';
import * as PunchListActionType from '../../Punch-List/constants';
import Translate from 'components/translate';
import { AppSettings } from '../../constants';
var yesterday = Moment().subtract( 1, 'day' );
var isValidAppointmentDate = function( current ){
    return current.isAfter( yesterday );
};
let isDisabled = true;
let originalState = null;

class EditWorkOrder extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    WorkOrderProfile: PropTypes.object,
    rfsInformation: PropTypes.object,
    WorkOrderTypeList: PropTypes.any,
    TradeList: PropTypes.any,
    ItemToRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    RoomList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    LotList: PropTypes.any,
    UserList: PropTypes.any,
    rfsId: PropTypes.string,
    workOrderId: PropTypes.string,
    onCancelClick: PropTypes.func,
    UserProfile: PropTypes.object,
    isPunchItem: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.woInformation = props.WorkOrderProfile && props.WorkOrderProfile.workOrder && props.WorkOrderProfile.workOrder.woInformation ? props.WorkOrderProfile.workOrder.woInformation : {} ;
    this.state = {
      title: this.woInformation.title,
      description: this.woInformation.description,
      appointmentDate: this.woInformation.appointmentDate?Moment(this.woInformation.appointmentDate):null,
      room: this.woInformation.room ? {
        value: this.woInformation.room.id,
        text: this.woInformation.room.name,
        extensionValue: null,
        selected: false
      } : null,
      trade: this.woInformation.trade ? {
        value: this.woInformation.trade.id,
        text: this.woInformation.trade.name,
        extensionValue: null,
        selected: false
      } : null,
      itemToRepair: this.woInformation.itemToRepair ? {
        value: this.woInformation.itemToRepair.id,
        text: this.woInformation.itemToRepair.description,
        extensionValue: null,
        selected: false
      } : null,
      subcontractor: this.woInformation.subcontractorProfile ? {
        value: this.woInformation.subcontractorProfile.subcontractorId,
        text: this.woInformation.subcontractorProfile.companyName,
        extensionValue: null,
        selected: false
      } : null,
      workOrderType: this.woInformation.workOrderType ? {
        value: this.woInformation.workOrderType.id,
        text: this.woInformation.workOrderType.name,
        extensionValue: null,
        selected: false
      } : null,
      problem: this.woInformation.problem ? {
        value: this.woInformation.problem.id,
        text: this.woInformation.problem.name,
        extensionValue: null,
        selected: false
      } : null,
      user: this.woInformation.assignedUser ? {
        value: this.woInformation.assignedUser.id,
        text: `${this.woInformation.assignedUser.displayName}`,
        extensionValue: {email: this.woInformation.assignedUser.email},
        selected: false
      } : null,
      isModeAssignSub: this.woInformation.assignedUser ? false : true,
      isLoadingLocation: false,
      isLoadingTrade: false,
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      isLoadingItemToRepair: false,
      isLoadingProblem: false,
      isLoadingWorkOrderType: false,
      isInitialUser: false,
      error: null
    };
    originalState = this.state;
    isDisabled = true;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.RoomList) {this.setState({isLoadingLocation: false});}
    if (nextProps.TradeList) {this.setState({isLoadingTrade: false});}
    if (nextProps.SubcontractorList) {this.setState({isLoadingSubcontractor: false});}
    if (nextProps.UserList) {this.setState({isLoadingUser: false});}
    if (nextProps.ItemToRepairList) {this.setState({isLoadingItemToRepair: false});}
    if (nextProps.ProblemList) {this.setState({isLoadingProblem: false});}
    if (nextProps.WorkOrderTypeList) {this.setState({isLoadingWorkOrderType: false});}
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState && originalState) {
      const checkStateChanged = (
        !shallowEqual(nextState.workOrderType, originalState.workOrderType) ||
        !shallowEqual(nextState.trade, originalState.trade) ||
        !shallowEqual(nextState.itemToRepair, originalState.itemToRepair) ||
        !shallowEqual(nextState.problem, originalState.problem) ||
        !shallowEqual(nextState.room, originalState.room) ||
        !shallowEqual(nextState.subcontractor, originalState.subcontractor) ||
        (nextState.user && !originalState.user) ||
        (!nextState.user && originalState.user) ||
        (nextState.user && originalState.user && nextState.user.value !== originalState.user.value) ||
        (nextState.title !== originalState.title) ||
        (nextState.description !== originalState.description) ||
        Moment(nextState.appointmentDate).format('MM/DD/YYYY hh/mm A') !==
        Moment(originalState.appointmentDate).format('MM/DD/YYYY hh/mm A')      
        );
      if (checkStateChanged) {
        isDisabled = false;
      } else {
        isDisabled = true;
      }
    }
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
    if (name === 'itemToRepair') {
      this.setState({
        problem: null
      });
    }
    if (name === 'trade') {
      this.setState({
        subcontractor: null,
        itemToRepair: null,
        problem: null
      });
    }
  }

  onChangeAppointmentDate = (appointmentDate) => {
    if (appointmentDate) {
      let currentDate = Moment(new Date());
      let currSelectedDate = Moment(appointmentDate._d);
      if(currentDate<=currSelectedDate){
      if (Moment(appointmentDate, "MM/DD/YYYY hh:mm A", true).isValid()) {
       this.setState({
          appointmentDate,
          error: null,
        });
      } 
      else {
        this.setState({
          error: "Invalid datetime.",
        });
      }
    } else {
      var selectedTime=Moment(appointmentDate._d,'MM/DD/YYYY hh:mm A').format('hh:mm A');
      this.setState({
        appointmentDate:Moment(appointmentDate._d,'MM/DD/YYYY hh:mm A').set({hour:Moment(selectedTime,'HH:mm').hour(), minute:Moment(selectedTime,'HH:mm').minute()}),
        error: null,
      });
    }
    } else {
      this.setState({
        appointmentDate,
        error: null,
      });
    }
  };

  fetchRoom = () => {
    this.setState({isLoadingLocation: true});
    this.props.dispatch({
      type: LotActionType.SELECT_ROOM_ASYNC,
      params: {
        id: this.props.WorkOrderProfile.requestDetail ? this.props.WorkOrderProfile.requestDetail.lot.id : this.props.rfsInformation.lot.id,
        searchKey: '',
        selectedValue: '',
        includeSystemRoom: true
      },
      callback: () => {
        this.setState({isFetchedRoom: true});
      }
    });
  }

  fetchTrade = () => {
    this.setState({isLoadingTrade: true});
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.WorkOrderProfile.requestDetail ? this.props.WorkOrderProfile.requestDetail.lot.id : this.props.rfsInformation.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      },
      callback: () => {
        this.setState({isFetchedTrade: true});
      }
    });

  }

  fetchWOT = () => {
    this.setState({isLoadingWorkOrderType: true});
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      },
      callback: () => {
        this.setState({isFetchedWorkOrderType: true});
      }
    });
  }

  fetchItemRepair = (trade) => {
    if (trade) {
      if (trade.id || trade.value) {
        this.setState({isLoadingItemToRepair: true});
        this.props.dispatch({
          type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
          params: {
            id: trade.id ? trade.id : trade.value,
            searchKey: '',
            selectedValue: '',
            setDefaultSelected: false
          },
          callback: () => {
            this.setState({isFetchedItemToRepair: true});
          }
        });
      }
    }
  }

  fetchSubcontractor = (trade) => {
    if (trade) {
      if (trade.id || trade.value) {
        this.setState({isLoadingSubcontractor: true});
        this.props.dispatch({
          type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
          params: {
            projectId: this.props.WorkOrderProfile.requestDetail ? this.props.WorkOrderProfile.requestDetail.project.id : this.props.rfsInformation.project.id,
            lotId: this.props.WorkOrderProfile.requestDetail ? this.props.WorkOrderProfile.requestDetail.lot.id : this.props.rfsInformation.lot.id,
            tradeId: trade.id ? trade.id : trade.value,
            param: {
              searchKey: '',
              selectedValue: ''
            }
          },
          callback: () => {
            this.setState({isFetchedSubcontractor: true});
          }
        });
      }
    }
  }

  fetchUser = () => {
    this.setState({isLoadingUser: true});
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.WorkOrderProfile.requestDetail ? this.props.WorkOrderProfile.requestDetail.project.id : this.props.rfsInformation.project.id
      },
      callback: () => {
        this.setState({isFetchedUser: true});
      }
    });
  }

  fetchProblem = (itemToRepair) => {
    if (itemToRepair) {
      if (itemToRepair.id || itemToRepair.value) {
        this.setState({isLoadingProblem: true});
        this.props.dispatch({
          type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
          params: {
            id: itemToRepair.id ? itemToRepair.id : itemToRepair.value,
            searchKey: ''
          },
          callback: () => {
            this.setState({isFetchedProblem: true});
          }
        });
      }
    }
  }

  renderDueDate = (dueDate) => {
    if (dueDate) {
      const value = daysBetween(new Date(), new Date(dueDate));
      const style = value >= 0 ? 'remaining-day-txt' : 'text-danger';
      const day = (value === 1 || value === -1) ? 'day' : 'days';
      return (
        <strong>{Moment(dueDate).format('MM/DD/YYYY')}
          <span className={style}> ({value >= 0 ? `${Math.abs(value)} ${day} remaining` : `${Math.abs(value)} ${day} overdue`})</span>
        </strong>
      );
    }
    return null;
  }

  handleChangeTitle = (e) => {
    this.setState({
      title: e.target.value
    });
  }

  handleChangeDescription = (e) => {
    this.setState({
      description: e.target.value
    });
  }

  handleOnClick = () => {
    this.props.onCancelClick();
  }

  handleModeAssign = mode => {
    if (mode === 'sub') {
      this.setState({isModeAssignSub: true, user: originalState.user});
    } else {
      this.setState({
        isModeAssignSub: false
      }, () => {
        this.setState({ subcontractor: this.state.trade ? originalState.subcontractor : null });
      });
      if (!this.state.user) {
        this.setState({
          user: {
            value: this.props.rfsInformation.managedByUser.id,
            text: this.props.rfsInformation.managedByUser.displayName,
            extensionValue: {email: this.props.rfsInformation.managedByUser.email},
            selected: false
          }
        });
      }
    }
  }

  getSelectOptions = (isFetched, currentOption, dataSource) => {
    if (isFetched) {
      //check is trade inactive
      if (currentOption) {
        const optionFound = dataSource.find(item => item.value === currentOption.value);
        if (!optionFound) {
          //current trade is inactive
          return [...dataSource, {...currentOption, except: true}];
        }
        return dataSource;
      }
      return dataSource;
    }
    return [{...currentOption}];
  }

  renderInternalUserDropdown = (userOptions) => {
    if (this.props.UserProfile.sso) {
      return <Dropdown
        onChange={ref => { this.onSelectChange(ref, 'user'); }}
        filter={true}
        className='filestring-dropdown filter-dropdown'
        onRemote={this.fetchUser}
        options={userOptions.map(item => { return {...item, text: `${item.text} (${item.extensionValue ? item.extensionValue.email : ''})`}; })}
        loading={this.state.isLoadingUser}
        optionLabel='text'
        value={this.state.user}
        showClear={true}
        groupLabels={[
          {
            label: 'System users',
            field: 'sso',
            condition: [true]
          },
          {
            label: 'Builder users',
            field: 'sso',
            condition: [false, null]
          }
        ]}
        name='user'
        placeholder='--Select a user'
        style={{ width: '100%' }} />;
    }
    return <Dropdown
      onChange={ref => { this.onSelectChange(ref, 'user'); }}
      filter={true}
      className='filestring-dropdown filter-dropdown'
      onRemote={this.fetchUser}
      options={userOptions.map(item => { return {...item, text: `${item.text} (${item.extensionValue ? item.extensionValue.email : ''})`}; })}
      loading={this.state.isLoadingUser}
      optionLabel='text'
      value={this.state.user}
      showClear={true}
      name='user'
      placeholder='--Select a user'
      style={{ width: '100%' }} />;
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { subcontractor, user, isModeAssignSub } = this.state;
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    if (woInformation.status === 1) {///status === Open
      let assignee = null;
      if (isModeAssignSub) {
        assignee = subcontractor ? subcontractor.value : null;
      } else {
        assignee = user ? user.value : null;
      }
      const showPopup = (
        (woInformation.assignedUser &&
        woInformation.assignedUser.id !== assignee) ||
        (woInformation.subcontractorProfile &&
          woInformation.subcontractorProfile.subcontractorId !== assignee)
      );
      if (showPopup) {
        //show popup
        this.setState({
          isDisplayPopoverReassign: true
        });
      } else {
        this.onSave();
      }
    } else {
      this.onSave();
    }
  }

  onSave = () => {
    const { room, trade, workOrderType, subcontractor, itemToRepair, problem, appointmentDate, user, isModeAssignSub } = this.state;
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const { isPunchItem } = this.props;
    const { title, description } = this.form.getValues();
    let params = null;

    if (woInformation.status === 6) {
      params = {
        title: title,
        description,
        tradeId: trade ? trade.value : null,
        itemToRepairId: itemToRepair ? itemToRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        problemId: problem ? problem.value : null
      };
    } else if (!isPunchItem || (isPunchItem && woInformation.status !== 2)) {
      params = {
        title: !isPunchItem ? title : woInformation.title,
        description,
        requestId: this.props.rfsId,
        tradeId: trade ? trade.value : null,
        roomId: room.value,
        itemToRepairId: itemToRepair ? itemToRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        workOrderTypeId: workOrderType ? workOrderType.value : null,
        problemId: problem ? problem.value : null,
        appointmentDate: Moment.isMoment(appointmentDate) ? Moment(appointmentDate).format() : appointmentDate,
        declinedReason: woInformation.declinedReason ? woInformation.declinedReason : null,
        lastClosedDate: woInformation.lastClosedDate ? woInformation.lastClosedDate : null,
        lastResolvedDate: woInformation.lastResolvedDate ? woInformation.lastResolvedDate : null
      };
    }
    else {
      params = {
        title: woInformation.title,
        description,
        tradeId: trade ? trade.value : null,
        roomId: room.value,
        itemToRepairId: itemToRepair ? itemToRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        problemId: problem ? problem.value : null,
        appointmentDate: Moment.isMoment(appointmentDate) ? Moment(appointmentDate).format() : appointmentDate,
        declinedReason: woInformation.declinedReason ? woInformation.declinedReason : null,
        lastClosedDate: woInformation.lastClosedDate ? woInformation.lastClosedDate : null,
        lastResolvedDate: woInformation.lastResolvedDate ? woInformation.lastResolvedDate : null,
        reopenReason: woInformation.reopenReason ? woInformation.reopenReason : null
      };
    }

    if (isModeAssignSub) {
      params.subcontractorId = subcontractor ? subcontractor.value : null;
    } else {
      params.assignedUserId = user ? user.value : null;
    }
    if (woInformation.status === 6) {
      this.props.dispatch({
        type: WorkOrderActionType.EDIT_REQUESTED_RE_OPEN_WORK_ORDER_ASYNC,
        params: {
          refNo: this.props.workOrderId,
          rfsId: this.props.rfsId,
          data: params
        },
        callback: () => {
          this.handleOnClick();
        }
      });
    } else if (!isPunchItem || (isPunchItem && woInformation.status !== 2)) {
      this.props.dispatch({
        type: WorkOrderActionType.UPDATE_WORK_ORDER_ASYNC,
        params: {
          data: params,
          refNo: this.props.workOrderId
        },
        callback: () => {
          this.handleOnClick();
        }
      });
    } else {
      this.props.dispatch({
        type: PunchListActionType.UPDATE_PUNCH_ITEM_ASYNC,
        params: {
          data: params,
          punchListRefNo: this.props.rfsId,
          punchItemRefNo: this.props.workOrderId
        },
        callback: () => {
          this.handleOnClick();
        }
      });
    }

  }

  validateAssignedTo(user, subcontractor) {
    if (this.state.isModeAssignSub) {
      return subcontractor;
    }
    return user;
  }

  checkRequiredField = () => {
    const { room, trade, subcontractor, itemToRepair, problem, user, title, workOrderType } = this.state;
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const { isPunchItem } = this.props;
    let isMatch = false;
    //punch item
    if (isPunchItem) {
      isMatch = room && trade && itemToRepair && problem && (subcontractor || user);
    }
    //pending
    else if (woInformation.status === 2) {
      isMatch = room && trade && itemToRepair && problem && (title !== '');
    }
    // scheduled
    else if (woInformation.status === 7) {
      isMatch = room && workOrderType && trade && itemToRepair && this.validateAssignedTo(user, subcontractor) && problem ;
    }
    //open
    else if (woInformation.status === 1) {
      isMatch = room && trade && itemToRepair && problem && (title !== '') && (subcontractor || user) && workOrderType;
    }

    else if (woInformation.status === 6) {
      isMatch = trade && itemToRepair && problem && (title !== '') && (subcontractor || user);
    }
    else {
      isMatch = room && (title !== '');
    }
    return isMatch;
  }

  renderWorkOrderValue = (value) => {
    if (value) {
      return <strong>{value}</strong>;
    }
    return <span style={{ 'opacity': '.5' }}>(Not specified)</span>;
  }

  renderRequiredText() {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    if (woInformation.status === 7) {
      return <span className='text-danger'> *</span>;
    }
    return null;
  }

  renderRequestHomeOwner() {
    // const { RFSProfile } = this.state;

    return (
      <div className='form-group'>
        <div className='col-sm-12'>
          <span className='text-danger'>This request is generated by <Translate translateKey='homeowner' /></span>
        </div>

      </div>
    );
  }

  renderAge = (item) => {
    // const day = item.age > 1 ? 'days' : 'day';
    const className = !item.overdue ? 'remaining-day-txt' : 'text-danger';
    return <strong className={className}>{item.age}</strong>;
  }

  renderWorkOrderStatus = (status) => {
    return <strong>{AppSettings.WO_STATUS_VALUE.find(x => x.key === status).value}</strong>;
  }

  renderWorkOrderReopenInformation() {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const checkIsMatch = this.checkRequiredField();

    let { title, description } = woInformation;
    if (this.form) {
      title = this.form.getValues(true).title;
      description = this.form.getValues(true).description;
    }

    const {
      isFetchedTrade, trade,
      isFetchedItemToRepair, itemToRepair,
      isFetchedProblem, problem,
      isFetchedSubcontractor, subcontractor,
      isFetchedUser, user
    } = this.state;

    const {
      TradeList,
      UserList,
      SubcontractorList,
      ItemToRepairList,
      ProblemList,
      isPunchItem
    } = this.props;

    const tradeOptions = this.getSelectOptions(isFetchedTrade, trade, TradeList);
    const userOptions = this.getSelectOptions(isFetchedUser, user, UserList);
    const subcontractorOptions = this.getSelectOptions(isFetchedSubcontractor, subcontractor, SubcontractorList);
    const itemToRepairOptions = this.getSelectOptions(isFetchedItemToRepair, itemToRepair, ItemToRepairList);
    const problemOptions = this.getSelectOptions(isFetchedProblem, problem, ProblemList);
    return (
      <div>
        <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
          <div className='row col-sm-12'>
            <label className='col-xs-6 col-sm-2 control-label form-siteone-label punch-item-label' style={{width: 150}}>Status</label>
            <div className='col-xs-6 col-sm-6 control-label name form-text-label punch-item-value' style={{paddingTop: '7px'}}>
              <strong>{this.renderWorkOrderStatus(woInformation.status)}</strong>
              {/* 3 === declined*/}
              {woInformation.status === 3 && woInformation.declinedReason &&
                <strong
                  className='text-danger'
                  style={{fontSize: 14, display: 'block'}}>
                  Reason: "{woInformation.declinedReason}"
                </strong>
              }
            </div>
          </div>

          <div className='row col-sm-12'>
            <label className='col-xs-6 col-sm-2 control-label form-siteone-label punch-item-label' style={{width: 150}}>Location</label>
            <div className='col-xs-6 col-sm-6 control-label name form-text-label punch-item-value' style={{paddingTop: '7px'}}>
              <strong>{this.renderWorkOrderValue(
                woInformation.room ? woInformation.room.name : null
              )}</strong>
            </div>
          </div>

          <div className='row col-sm-12'>
            <label className='col-xs-6 col-sm-2 control-label form-siteone-label punch-item-label' style={{width: 150}}>Work order type</label>
            <div className='col-xs-6 col-sm-6 control-label name form-text-label punch-item-value' style={{paddingTop: '7px'}}>
              <strong>{this.renderWorkOrderValue(
                woInformation.workOrderType
                  ? woInformation.workOrderType.name
                  : null
              )}</strong>
            </div>
          </div>

          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Trade <span className='text-danger'>*</span>
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'trade'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={tradeOptions}
                  optionLabel='text'
                  onRemote={this.fetchTrade}
                  value={this.state.trade}
                  loading={this.state.isLoadingTrade}
                  showClear={true}
                  placeholder='Please select'
                  style={{ width: '100%' }} />
              </div>
            </div>
            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0, paddingTop: 3}}>
              <div className='col-sm-12 control-label form-siteone-label' style={{marginBottom: 5}}>
              Assigned to <span className='text-danger'>*</span>
                <div className='btn-group btn-group-sm wo-assign-btn-group' role='group'>
                  <button
                    type='button'
                    className={'btn btn-secondary ' + (this.state.isModeAssignSub ? 'active' : '')}
                    onClick={() => {this.handleModeAssign('sub');}}>subcontractor</button>
                  <button
                    type='button'
                    className={'btn btn-secondary ' + (!this.state.isModeAssignSub ? 'active' : '')}
                    onClick={() => {this.handleModeAssign('user');}}>internal user</button>
                </div>
              </div>
              <div className='col-sm-12' style={{paddingLeft: 15, paddingRight: 0}}>
                {this.state.isModeAssignSub
                  ? (
                    <Dropdown
                      onChange={ref => { this.onSelectChange(ref, 'subcontractor'); }}
                      filter={true}
                      className='filestring-dropdown filter-dropdown'
                      onRemote={() => {this.fetchSubcontractor(this.state.trade);}}
                      options={subcontractorOptions}
                      optionLabel='text'
                      value={this.state.subcontractor}
                      loading={this.state.isLoadingSubcontractor}
                      disabled={!this.state.trade}
                      showClear={true}
                      name='subcontractor'
                      placeholder='--Select a trade first'
                      style={{ width: '100%' }} />
                  ) : (
                    this.renderInternalUserDropdown(userOptions)
                  )}
              </div>
            </div>
          </div>
          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Item to repair <span className='text-danger'>*</span>
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'itemToRepair'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={itemToRepairOptions}
                  optionLabel='text'
                  disabled={!this.state.trade}
                  onRemote={() => {this.fetchItemRepair(this.state.trade);}}
                  value={this.state.itemToRepair}
                  loading={this.state.isLoadingItemToRepair}
                  showClear={true}
                  placeholder='Select a trade first'
                  style={{ width: '100%' }} />
              </div>
            </div>

            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Problem <span className='text-danger'> *</span>
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'problem'); }}
                  className='filestring-dropdown filter-dropdown'
                  options={problemOptions}
                  optionLabel='text'
                  disabled={!this.state.itemToRepair}
                  onRemote={() => {this.fetchProblem(this.state.itemToRepair);}}
                  value={this.state.problem}
                  loading={this.state.isLoadingProblem}
                  showClear={true}
                  placeholder='Select an item to repair first'
                  style={{ width: '100%' }} />
              </div>
            </div>
          </div>

          {!isPunchItem &&
          <div className='row col-sm-12 form-group'>
            <label className='col-sm-12 control-label form-siteone-label'>Summary<span className='text-danger'> *</span></label>
            <div className='col-sm-12 control-label name form-text-label' style={{paddingLeft: 15}}>
              <Input
                type='text'
                name='title'
                ref='title'
                className='form-control'
                // onBlur={() => this.setState({title: this.form.getValues().title})}
                onChangeCallback={(value) => { this.setState({ title: value }); }}
                value={title}
                max='200'
                maxLength='200'
                validations={[Vali.required, Vali.maxlength]} />
            </div>
          </div>
          }

          <div className='row col-sm-12 form-group'>
            <div className='form-group'>
              <label className='col-sm-12 control-label form-siteone-label'>Description {!isPunchItem && <span className='text-danger' />}</label>
              <div className='col-sm-12 control-label name form-text-label' style={{paddingLeft: 15}}>
                <Textarea
                  name='description'
                  ref='description'
                  className='form-control'
                  // onBlur={() => this.setState({description: this.form.getValues().description})}
                  onChangeCallback={(value) => { this.setState({ description: value }); }}
                  value={description}
                  max='1000'
                  maxLength='1000'
                  style={{ height: 130 }}
                  validations={[Vali.maxlength]} />
              </div>
            </div>
          </div>

          <div className='row col-sm-12'>
            <label className='col-xs-6 col-sm-2 control-label form-siteone-label punch-item-label' style={{width: 150}}>Appointment</label>
            <div className='col-xs-6 col-sm-6 control-label name form-text-label punch-item-value' style={{paddingTop: '7px'}}>
              <strong>{this.renderWorkOrderValue(
                woInformation.appointmentDate
                  ? Moment(woInformation.appointmentDate).format(
                    'MM/DD/YYYY hh:mm A'
                  )
                  : null
              )}</strong>
            </div>
          </div>

          <div className='row col-sm-12'>
            <label className='col-xs-6 col-sm-2 control-label form-siteone-label punch-item-label' style={{width: 150}}>Last resolved</label>
            <div className='col-xs-6 col-sm-6 control-label name form-text-label punch-item-value' style={{paddingTop: '7px'}}>
              <strong>{this.renderWorkOrderValue(
                woInformation.lastResolvedDate
                  ? Moment(woInformation.lastResolvedDate).format(
                    'MM/DD/YYYY'
                  )
                  : null
              )}</strong>
            </div>
          </div>

          <div className='row col-sm-12'>
            <label className='col-xs-6 col-sm-2 control-label form-siteone-label punch-item-label' style={{width: 150}}>Last closed</label>
            <div className='col-xs-6 col-sm-6 control-label name form-text-label punch-item-value' style={{paddingTop: '7px'}}>
              <strong>
                {this.renderWorkOrderValue(
                  woInformation.lastClosedDate
                    ? Moment(woInformation.lastClosedDate).format(
                      'MM/DD/YYYY'
                    )
                    : null
                )}
              </strong>
            </div>
          </div>

          <ul className='wo-detail-bottom-btn'>
            <li>
              <span
                className='btn btn-primary btn-siteone-default btn-wo-edit punch-item-cancel-btn'
                onClick={this.handleOnClick}>
                Cancel
              </span>
            </li>
            <li>
              <Submit
                className='btn btn-primary btn-submit btn-siteone'
                disabled={isDisabled || !checkIsMatch || this.state.error}>
                Save
              </Submit>
            </li>
          </ul>
        </Form>
      </div>
    );
  }

  renderWorkOrderInformation() {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const checkIsMatch = this.checkRequiredField();

    let { title, description } = woInformation;
    if (this.form) {
      title = this.form.getValues(true).title;
      description = this.form.getValues(true).description;
    }

    const {
      isFetchedTrade, trade,
      isFetchedWorkOrderType, workOrderType,
      isFetchedRoom, room,
      isFetchedItemToRepair, itemToRepair,
      isFetchedProblem, problem,
      isFetchedSubcontractor, subcontractor,
      isFetchedUser, user
    } = this.state;

    const {
      TradeList,
      WorkOrderTypeList,
      RoomList,
      UserList,
      SubcontractorList,
      ItemToRepairList,
      ProblemList,
      isPunchItem
    } = this.props;

    const tradeOptions = this.getSelectOptions(isFetchedTrade, trade, TradeList);
    const workOrderTypeOptions = this.getSelectOptions(isFetchedWorkOrderType, workOrderType, WorkOrderTypeList);
    const locationOptions = this.getSelectOptions(isFetchedRoom, room, RoomList);
    const userOptions = this.getSelectOptions(isFetchedUser, user, UserList);
    const subcontractorOptions = this.getSelectOptions(isFetchedSubcontractor, subcontractor, SubcontractorList);
    const itemToRepairOptions = this.getSelectOptions(isFetchedItemToRepair, itemToRepair, ItemToRepairList);
    const problemOptions = this.getSelectOptions(isFetchedProblem, problem, ProblemList);

    // let summaryDescriptionChanged = true;

    return (
      <div>
        <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
          <div className='row col-sm-12'>
            <label className='col-xs-6 col-sm-2 control-label form-siteone-label punch-item-label' style={{width: 150}}>Status</label>
            <div className='col-xs-6 col-sm-6 control-label name form-text-label punch-item-value' style={{paddingTop: '7px'}}>
              <strong>{this.renderWorkOrderStatus(woInformation.status)}</strong>
              {/* 3 === declined*/}
              {woInformation.status === 3 && woInformation.declinedReason &&
                <strong
                  className='text-danger'
                  style={{fontSize: 14, display: 'block'}}>
                  Reason: "{woInformation.declinedReason}"
                </strong>
              }
            </div>
          </div>

          {woInformation.status === 1 &&
            <div className='row col-sm-12'>
              <div className='col-xs-12 col-sm-6' style={{paddingLeft: 0}}>
                <label className='col-xs-6 col-sm-6 control-label form-siteone-label punch-item-label' style={{width: 150}}>Total age</label>
                <div className='col-xs-5 col-sm-3 control-label name form-text-label punch-item-value' style={{paddingTop: '7px', marginLeft: 3}}>
                  <strong>{woInformation.totalAge}</strong>
                </div>
              </div>
              <div className='col-xs-12 col-sm-6' style={{paddingLeft: 0}}>
                <label className='col-xs-6 col-sm-6 control-label form-siteone-label punch-item-label' style={{width: 150}}>Age of assignment</label>
                <div className='col-xs-5 col-sm-3 control-label name form-text-label punch-item-value' style={{paddingTop: '7px', marginLeft: 3}}>
                  {this.renderAge(woInformation)}
                </div>
              </div>
            </div>
          }

          {!isPunchItem &&
          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{padding: 0}}>
              <label className='col-sm-12 control-label form-siteone-label'>Work order type
                {(woInformation.status === 1 || woInformation.status === 7) && <span className='text-danger'> *</span>}</label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'workOrderType'); }}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchWOT}
                  options={workOrderTypeOptions}
                  optionLabel='text'
                  value={this.state.workOrderType}
                  loading={this.state.isLoadingWorkOrderType}
                  showClear={true}
                  placeholder='Please select'
                  style={{ width: '100%' }} />
              </div>
            </div>
          </div>
          }

          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{padding: 0}}>
              <label className='col-sm-12 control-label form-siteone-label'>Location <span className='text-danger'>*</span></label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'room'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchRoom}
                  options={locationOptions}
                  optionLabel='text'
                  value={this.state.room}
                  loading={this.state.isLoadingLocation}
                  showClear={true}
                  placeholder='Please select'
                  style={{ width: '100%' }} />
              </div>
            </div>
          </div>

          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Trade {(woInformation.status === 1 || woInformation.status === 2 || woInformation.status === 7) && <span className='text-danger'>*</span>}
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'trade'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={tradeOptions}
                  optionLabel='text'
                  onRemote={this.fetchTrade}
                  value={this.state.trade}
                  loading={this.state.isLoadingTrade}
                  showClear={true}
                  placeholder='Please select'
                  style={{ width: '100%' }} />
              </div>
            </div>
            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0, paddingTop: 3}}>
              <div className='col-sm-12 control-label form-siteone-label' style={{marginBottom: 5}}>
              Assigned to {(woInformation.status === 1 || woInformation.status === 7 || isPunchItem) && <span className='text-danger'>*</span>}
                <div className='btn-group btn-group-sm wo-assign-btn-group' role='group'>
                  <button
                    type='button'
                    className={'btn btn-secondary ' + (this.state.isModeAssignSub ? 'active' : '')}
                    onClick={() => {this.handleModeAssign('sub');}}>subcontractor</button>
                  <button
                    type='button'
                    className={'btn btn-secondary ' + (!this.state.isModeAssignSub ? 'active' : '')}
                    onClick={() => {this.handleModeAssign('user');}}>internal user</button>
                </div>
              </div>
              <div className='col-sm-12' style={{paddingLeft: 15, paddingRight: 0}}>
                {this.state.isModeAssignSub
                  ? (
                    <Dropdown
                      onChange={ref => { this.onSelectChange(ref, 'subcontractor'); }}
                      filter={true}
                      className='filestring-dropdown filter-dropdown'
                      onRemote={() => {this.fetchSubcontractor(this.state.trade);}}
                      options={subcontractorOptions}
                      optionLabel='text'
                      value={this.state.subcontractor}
                      loading={this.state.isLoadingSubcontractor}
                      disabled={!this.state.trade}
                      showClear={true}
                      name='subcontractor'
                      placeholder='--Select a trade first'
                      style={{ width: '100%' }} />
                  ) : (
                    this.renderInternalUserDropdown(userOptions)
                  )}
              </div>
            </div>
          </div>
          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Item to repair {(woInformation.status === 1 || woInformation.status === 2 || woInformation.status === 7) && <span className='text-danger'>*</span>}
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'itemToRepair'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={itemToRepairOptions}
                  optionLabel='text'
                  disabled={!this.state.trade}
                  onRemote={() => {this.fetchItemRepair(this.state.trade);}}
                  value={this.state.itemToRepair}
                  loading={this.state.isLoadingItemToRepair}
                  showClear={true}
                  placeholder='Select a trade first'
                  style={{ width: '100%' }} />
              </div>
            </div>
            <div className='col-sm-6' style={{paddingLeft: 0, paddingRight: 0}}>
              <label
                className='col-sm-12 control-label form-siteone-label'>
                Problem {(woInformation.status === 1 || woInformation.status === 2 || woInformation.status === 7) && <span className='text-danger'> *</span>}
              </label>
              <div className='col-sm-12' style={{paddingLeft: 15}}>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'problem'); }}
                  className='filestring-dropdown filter-dropdown'
                  options={problemOptions}
                  optionLabel='text'
                  disabled={!this.state.itemToRepair}
                  onRemote={() => {this.fetchProblem(this.state.itemToRepair);}}
                  value={this.state.problem}
                  loading={this.state.isLoadingProblem}
                  showClear={true}
                  placeholder='Select an item to repair first'
                  style={{ width: '100%' }} />
              </div>
            </div>
          </div>

          {!isPunchItem &&
          <div className='row col-sm-12 form-group'>
            <label className='col-sm-12 control-label form-siteone-label'>Summary<span className='text-danger'> *</span></label>
            <div className='col-sm-12 control-label name form-text-label' style={{paddingLeft: 15}}>
              <Input
                type='text'
                name='title'
                ref='title'
                className='form-control'
                // onBlur={() => this.setState({title: this.form.getValues().title})}
                onChangeCallback={(value) => { this.setState({ title: value }); }}
                value={title}
                max='200'
                maxLength='200'
                validations={[Vali.required, Vali.maxlength]} />
            </div>
          </div>
          }

          <div className='row col-sm-12 form-group'>
            <div className='form-group'>
              <label className='col-sm-12 control-label form-siteone-label'>Description {!isPunchItem && <span className='text-danger' />}</label>
              <div className='col-sm-12 control-label name form-text-label' style={{paddingLeft: 15}}>
                <Textarea
                  name='description'
                  ref='description'
                  className='form-control'
                  // onBlur={() => this.setState({description: this.form.getValues().description})}
                  onChangeCallback={(value) => { this.setState({ description: value }); }}
                  value={description}
                  max='1000'
                  maxLength='1000'
                  style={{ height: 130 }}
                  validations={[Vali.maxlength]} />
              </div>
            </div>
          </div>

          <div className='row col-sm-12 form-group'>
            <div className='form-group'>
              <label className='col-sm-12 control-label form-siteone-label'>Appointment</label>
              <div className='col-sm-5 control-label name form-text-label' style={{paddingLeft: 15}}>
                <Datetime
                  ref={ref => { this.appointmentDate = ref; }}
                  name='appointmentDate'
                  initialViewDate={woInformation.appointmentDate?Moment(woInformation.appointmentDate)
                    :Moment(new Date()).set({ hour: 9, minute: 0 })}
                  inputProps={{ placeholder: 'mm/dd/yyyy hh:mm' }}
                  value={this.state.appointmentDate}
                  onChange={this.onChangeAppointmentDate} 
                  closeOnSelect={true}
                  isValidDate={isValidAppointmentDate}
                />
                {this.state.error &&
                  <span className='text-danger' style={{fontSize: 12}}>{this.state.error}</span>
                }
              </div>
            </div>
          </div>

          <ul className='wo-detail-bottom-btn'>
            <li>
              <span
                className='btn btn-primary btn-siteone-default btn-wo-edit punch-item-cancel-btn'
                onClick={this.handleOnClick}>
                Cancel
              </span>
            </li>
            <li>
              {this.state.isDisplayPopoverReassign &&
                <Popup ref={(ref) => { this.reassignPopup = ref; }} isHasFaded={true} styles={{
                  width: 500,
                  top: -200,
                  left: 160,
                  padding: 20,
                  paddingTop: 30,
                  borderRadius: 2
                }}>
                  <div>
                    <span>You have just specified another assignee.</span><br />
                    <span>Saving this change will also send this work order to the new assignee and reset the due date.</span>
                    <div style={{marginTop: 20}}>
                      <button
                        className='btn btn-primary btn-siteone-default'
                        onClick={() => this.setState({isDisplayPopoverReassign: false})}>Cancel</button>
                      <button
                        className='btn btn-primary btn-submit btn-siteone'
                        onClick={this.onSave}>Save & Send</button>
                    </div>
                  </div>
                </Popup>
              }
              <Submit
                className='btn btn-primary btn-submit btn-siteone'
                disabled={isDisabled || !checkIsMatch || this.state.error}>
                Save
              </Submit>
            </li>
          </ul>
        </Form>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.woInformation.status === 6 ? this.renderWorkOrderReopenInformation() : this.props.WorkOrderProfile && this.props.WorkOrderProfile.workOrder.woInformation &&
          this.renderWorkOrderInformation()
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WorkOrderTypeList: state.WorkOrderTypesStore.WOTList,
    TradeList: state.LotStore.TradeList,
    ItemToRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    LotList: state.ProjectStore.LotList,
    RoomList: state.LotStore.RoomList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    UserList: state.ProjectStore.UserSelectList,
    UserProfile: state.UserStore.UserProfile
  };
};

export default connect(mapStateToProps)(EditWorkOrder);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/edit-work-order.js